// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action } from '@ngrx/store';
import { RoleDetail, Role, IAMUser, ScopeCategory, ScopeConstraint } from '@app/core';
import { Group } from '../core/models/groups.model';

export enum RoleDetailsActionTypes {
  SELECT_ROLE = '[Role Details] SELECT_ROLE',
  SELECT_USERS_FOR_ROLE = '[Role Details] SELECT_USERS_FOR_ROLE',
  SELECT_SCOPE_CATEGORY = '[Role Details] SELECT_SCOPE_CATEGORY',
  SELECT_SCOPE_CONSTRAINTS = '[Role Details] SELECT_SCOPE_CONSTRAINTS',
  ROLE_DETAILS_LOADING = '[Role Details] ROLE_DETAILS_LOADING',
  ROLE_DETAILS_LOAD_COMPLETE = '[Role Details] ROLE_DETAILS_LOAD_COMPLETE',
  ROLE_DETAILS_LOAD_FAILED = '[Role Details] ROLE_DETAILS_LOAD_FAILED',
  CLEAR_ROLE_USER_SELECTIONS = '[Role Details] CLEAR_ROLE_USER_SELECTIONS',
  REMOVE_GROUP_FROM_ROLE = '[Role Details] REMOVE_GROUP_FROM_ROLE',
  SELECT_GROUPS_FOR_ROLE = '[Role Details] SELECT_GROUPS_FOR_ROLE',
  CLEAR_ROLE_GROUP_SELECTIONS = '[Role Details] CLEAR_ROLE_GROUP_SELECTIONS',
  SELECT_SCOPE_CATEGORY_FOR_GROUP = '[Role Details] SELECT_SCOPE_CATEGORY_FOR_GROUP',
  SELECT_SCOPE_CONSTRAINTS_FOR_GROUP = '[Role Details] SELECT_SCOPE_CONSTRAINTS_FOR_GROUP',
  ORG_ROLE_DETAILS_LOADING = '[Role Details] ORG_ROLE_DETAILS_LOADING',
  ORG_ROLE_DETAILS_LOAD_COMPLETE = '[Role Details] ORG_ROLE_DETAILS_LOAD_COMPLETE',
  ORG_ROLE_DETAILS_LOAD_FAILED = '[Role Details] ORG_ROLE_DETAILS_LOAD_FAILED'
}

export class SelectRoleAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_ROLE;
  constructor(public payload: Role) {
    this.payload = payload;
  }
}

export class SelectUsersForRoleAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_USERS_FOR_ROLE;
  constructor(public payload: { roleId: string; selectedUsers: IAMUser[] }) {
    this.payload = payload;
  }
}

export class SelectScopeCategoryAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_SCOPE_CATEGORY;
  constructor(public payload: { roleId: string; category: ScopeCategory }) {
    this.payload = payload;
  }
}

export class SelectScopeCategoryForGroupAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_SCOPE_CATEGORY_FOR_GROUP;
  constructor(public payload: { roleId: string; category: ScopeCategory }) {
    this.payload = payload;
  }
}

export class SelectScopeConstraintsAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_SCOPE_CONSTRAINTS;
  constructor(public payload: { roleId: string; constraints: ScopeConstraint[] }) {
    this.payload = payload;
  }
}

export class SelectScopeConstraintsForGroupAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_SCOPE_CONSTRAINTS_FOR_GROUP;
  constructor(public payload: { roleId: string; constraints: ScopeConstraint[] }) {
    this.payload = payload;
  }
}

export class LoadingRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ROLE_DETAILS_LOADING;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export class CompleteLoadRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ROLE_DETAILS_LOAD_COMPLETE;
  constructor(public payload: RoleDetail) {
    this.payload = payload;
  }
}

export class FailLoadRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ROLE_DETAILS_LOAD_FAILED;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export class ClearRoleUserSelectionsAction implements Action {
  readonly type = RoleDetailsActionTypes.CLEAR_ROLE_USER_SELECTIONS;
  constructor(public payload: string) {
    this.payload = payload;
  }
}

export class ClearRoleGroupSelectionsAction implements Action {
  readonly type = RoleDetailsActionTypes.CLEAR_ROLE_GROUP_SELECTIONS;
  constructor(public payload: string) {}
}

export class RemoveGroupFromRoleAction implements Action {
  readonly type = RoleDetailsActionTypes.REMOVE_GROUP_FROM_ROLE;
  constructor(public payload: string, public grant_id: string) {}
}

export class SelectGroupsForRoleAction implements Action {
  readonly type = RoleDetailsActionTypes.SELECT_GROUPS_FOR_ROLE;
  constructor(public payload: { roleId: string; selectedGroups: Group[] }) {}
}

export class OrgLoadingRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ORG_ROLE_DETAILS_LOADING;
  constructor(public payload: { orgId: string; roleId: string }) {
    this.payload = payload;
  }
}

export class OrgCompleteLoadRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ORG_ROLE_DETAILS_LOAD_COMPLETE;
  constructor(public payload: RoleDetail) {
    this.payload = payload;
  }
}

export class OrgFailLoadRoleDetailsAction implements Action {
  readonly type = RoleDetailsActionTypes.ORG_ROLE_DETAILS_LOAD_FAILED;
  constructor(public payload: { orgId: string; roleId: string }) {
    this.payload = payload;
  }
}

export type RoleDetailsActionsUnion =
  | SelectRoleAction
  | SelectUsersForRoleAction
  | SelectScopeCategoryAction
  | SelectScopeConstraintsAction
  | LoadingRoleDetailsAction
  | CompleteLoadRoleDetailsAction
  | FailLoadRoleDetailsAction
  | ClearRoleUserSelectionsAction
  | RemoveGroupFromRoleAction
  | SelectGroupsForRoleAction
  | SelectScopeCategoryForGroupAction
  | SelectScopeConstraintsForGroupAction
  | ClearRoleGroupSelectionsAction
  | OrgLoadingRoleDetailsAction
  | OrgCompleteLoadRoleDetailsAction
  | OrgFailLoadRoleDetailsAction;



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-details.actions.ts